// <head> metadata for Webcast2025InReviewWithMikeStonebrakerAndAndyPavloPage (https://www.dbos.dev/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: '2025 in Review with Mike Stonebraker and Andy Pavlo',
    },
    {
      name: 'description',
      content:
        'Webcast Dec 10: DBMS researchers Mike Stonebraker (MIT / DBOS) and Andy Pavlo (CMU) discuss which data and CS trends are heating up or cooling down heading into 2026.',
    },
    {
      property: 'og:title',
      content: '2025 in Review with Mike Stonebraker and Andy Pavlo',
    },
    {
      property: 'og:description',
      content:
        'Webcast Dec 10: DBMS researchers Mike Stonebraker (MIT / DBOS) and Andy Pavlo (CMU) discuss which data and CS trends are heating up or cooling down heading into 2026.',
    },
    {
      property: 'og:image',
      content:
        'https://www.dbos.dev/assets/images/692cf45e97f69d6805a52c75_Mike-Stonebraker-Andy-Pavlo-2025-in-Review3.jpg',
    },
    {
      name: 'twitter:title',
      content: '2025 in Review with Mike Stonebraker and Andy Pavlo',
    },
    {
      name: 'twitter:description',
      content:
        'Webcast Dec 10: DBMS researchers Mike Stonebraker (MIT / DBOS) and Andy Pavlo (CMU) discuss which data and CS trends are heating up or cooling down heading into 2026.',
    },
    {
      name: 'twitter:image',
      content:
        'https://www.dbos.dev/assets/images/692cf45e97f69d6805a52c75_Mike-Stonebraker-Andy-Pavlo-2025-in-Review3.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/webcast-2025-in-review-with-mike-stonebraker-and-andy-pavlo',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
